import React from 'react'

const ChartTooltip = ({ active, payload, label, formatter }) => {
  if (!active || !payload || payload.length === 0) return null

  return (
    <div
      style={{
        background: 'var(--color-tooltip-bg)',
        backdropFilter: 'blur(16px)',
        border: '1px solid var(--color-border)',
        borderRadius: '12px',
        padding: '12px 16px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
      }}
    >
      {label && (
        <p style={{ color: 'var(--color-text-muted)', fontSize: '12px', marginBottom: '8px', fontWeight: 500 }}>
          {label}
        </p>
      )}
      {payload.map((entry, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: index < payload.length - 1 ? '4px' : 0 }}>
          <div
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: entry.color,
            }}
          />
          <span style={{ color: 'var(--color-text)', fontSize: '13px', fontWeight: 600 }}>
            {formatter ? formatter(entry.value, entry.name) : `${parseFloat(entry.value).toFixed(2)} zł`}
          </span>
        </div>
      ))}
    </div>
  )
}

export default ChartTooltip
